// © Microsoft Corporation. All rights reserved.

/**
 * Helper to promisify the Prime 'require' AMD helper to resolve a single module with no dependencies.
 * @param moduleName {string} - the name of the module to resolve
 * @param defaultModule {TModule} - the default module implementation if require is not available.
 * @returns {Promise{TModule}} a promise that will resolve the module when it's available.
 * @description Note that this version only resolves a single module with no dependencies.
 */
export async function requireAsync<TModule>(moduleName: string, defaultModule?: TModule): Promise<TModule> {
    return new Promise((resolve: (module: TModule) => void, reject) => {

        if (typeof window.require === "function") {
            window.require([moduleName], resolve);
        } else if (defaultModule) {
            console.error(`require was not available. Returning default implementation for ${moduleName}`);
            resolve(defaultModule);
        } else {
             reject("require is not available");
        }
    });
}
